import { MarketConfig } from "@customer-tools-web/market-extension-resolver";

interface BaseLink {
  key?: string;
  link?: string;
  alternateLink?: string[];
  subMenus?: Array<BaseLink | null>;
}

export const matchActiveKey = (
  items: BaseLink[],
  alternateLink: boolean = false
) => {
  const currentPath = location.pathname.replace(/[\/\#]$/, "") || "";
  const currentItem = items
    .map((item) => (item.subMenus || []).concat([item]))
    .reduce((a, b) => a.concat(b))
    .filter((item) => !!item?.link)
    .sort((a, b) => b!.link!.length - a!.link!.length) // sort desendingly to find longest match
    .find(
      (item) =>
        currentPath === item?.link?.replace(/\/$/, "") ||
        (alternateLink &&
          item?.alternateLink?.find(
            (l) => currentPath === l.replace(/\/$/, "")
          ))
    );
  return (currentItem && currentItem.key) || "";
};

export const generateSharpieImgUrl = (
  config: MarketConfig,
  url: string,
  position: [number, number] = [128, 128],
  pattern: string = "fit",
  whiteMarker: boolean = true
) => {
  if (position && url) {
    const [width, height] = position;
    const sharpieHost =
      process.env.REACT_APP_SHARPIE_HOST ||
      "https://sharpie.dev.img.iproperty.com.my";
    const name = url.split("/").pop();
    const marker = whiteMarker ? "" : "/premium";
    const sharpieUrl = `${sharpieHost}/${config.sharpieBucket}${marker}/${width}x${height}-${pattern}/${name}`;

    return sharpieUrl;
  }

  return url;
};

export const generateLogoutUrl = () => {
  const pgAuthUrl =
    process.env.REACT_APP_PG_AUTH_ACCOUNT_SETTING ||
    "https://accounts.iproperty.com.my";
  const clientId =
    process.env.REACT_APP_PRO_CLIENT_ID ||
    "4d2fe63f-bdfa-41b7-b6bc-03dbed3bec55";
  const logoutUrl =
    process.env.REACT_APP_PRO_LOGOUT ||
    "https://www.iproperty.com.my/users/logout";
  const state = "nlg";
  return `${pgAuthUrl}/logout?client_id=${clientId}&logout_uri=${logoutUrl}&state=${state}`;
};

export const setLocalStorageItem = (name: string, value: string | null) => {
  if (value) {
    localStorage.setItem(name, value);
  }
};
